import React from "react";
import "./SetApart.css";
import iconOne from "../../../assets/images/iconone.webp";
import iconTwo from "../../../assets/images/icontwo.webp";
import iconThree from "../../../assets/images/iconthree.webp";
import bg from "../../../assets/images/bg.webp";
import lowprofit from "../../../assets/images/lowprofit.gif"
import payout from "../../../assets/images/payou.gif"
import setapart from '../../../assets/images/dollar.gif'

export default function SetApart() {
  const features = [
    {
      title: "Low Profit Target",
      text: "Our model features the industry's lowest phase 1 profit target. Achieving a 7% profit target in phase 1 is notably more attainable compared to the 8-10% targets required by other proprietary firms.",
      image: lowprofit, // Replace with actual image path or URL
    },
    {
      title: "Freedom without Restrictions",
      text: "At our firm, Freedom without Restrictions is more than just a slogan! We offer complete flexibility with no time limits, allowing EAs, trade copiers, and holding trades over weekends. There are no lot size limits or restrictions on martingale/hedging strategies.",
      image: payout, // Replace with actual image path or URL
    },
    {
      title: "Payouts Every Week",
      text: "Our profit-sharing model boasts an industry-leading 80% split, with payouts available via the dashboard just 7 days after your initial trade.",
      image: setapart, // Replace with actual image path or URL
    },
  ];

  return (
    <div className="setapart__container" style={{position:'relative'}}>
         <img
          src={bg}
          style={{
            position: "absolute",
            display: "block",
            margin: "0 auto", // centers the image horizontally
            paddingTop: "1px", // small padding at the top
            width: "100%", // image width relative to the parent
            maxWidth: "100%", // prevents overflow from parent
            height: "auto", // maintains aspect ratio
            zIndex:1
          
          
          ,
          pointerEvents: 'none'
          }}
               loading='lazy'
               alt="bg"
        />
      <div className="mainb">
   
      </div>
      <div>
        <p className="setapart__title">What Sets Us Apart?</p>
      </div>

      <div className="setapart__data">
        {features.map((item) => {
          return (
            <div className="setapart__item">
              <img src={item.image}      loading='lazy' alt="numbers" />
             
              <p>{item.title}</p>
              <p>{item.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
